export default "__VITE_ASSET__mxBrL35f__"